import {TrackPlayer} from './trackPlayer';
import {ITrackPlayer, RepeatMode} from './types';

export {TrackPlayer, RepeatMode};
export type {ITrackPlayer};

export default TrackPlayer;
